import { useState, useEffect } from 'react';

/**
 * Détecte l'état de connexion du navigateur (en ligne / hors-ligne).
 * S'abonne aux événements natifs window.online / window.offline.
 *
 * @returns {boolean} true = hors-ligne
 */
export function useOfflineStatus() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline  = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online',  handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online',  handleOnline);
    };
  }, []);

  return isOffline;
}
